import {encryptDes, decryptDes} from '../assets/js/common'

const AccessTokenKey = 'ACCESS_TOKEN'
const RefreshTokenKey = 'REFRESH_TOKEN'

// ========== Token 相关 ==========

export function getAccessToken () {
  return localStorage.getItem(AccessTokenKey)
}

export function getRefreshToken () {
  return localStorage.getItem(RefreshTokenKey)
}

export function setToken (token) {
  localStorage.setItem(AccessTokenKey, token)
  localStorage.setItem(RefreshTokenKey, token)
}

export function removeToken () {
  localStorage.removeItem(AccessTokenKey)
  localStorage.removeItem(RefreshTokenKey)
}

// ========== 账号相关 ==========

const UsernameKey = 'USERNAME'
const PasswordKey = 'PASSWORD'
const RememberMeKey = 'REMEMBER_ME'

export function getUsername () {
  return localStorage.getItem(UsernameKey)
}

export function setUsername (username) {
  localStorage.setItem(UsernameKey, username)
}

export function removeUsername () {
  localStorage.removeItem(UsernameKey)
}

export function getPassword () {
  const password = localStorage.getItem(PasswordKey)
  return password ? decryptDes(password) : undefined
}

export function setPassword (password) {
  localStorage.setItem(PasswordKey, encryptDes(password))
}

export function removePassword () {
  localStorage.removeItem(PasswordKey)
}

export function getRememberMe () {
  return localStorage.getItem(RememberMeKey) === 'true'
}

export function setRememberMe (rememberMe) {
  localStorage.setItem(RememberMeKey, rememberMe)
}

export function removeRememberMe () {
  localStorage.removeItem(RememberMeKey)
}

// 仅存储登录信息
export function setLoginInfo (loginInfo) {
  localStorage.setItem('loginInfo', JSON.stringify(loginInfo))
}

// 仅获取登录信息
export function getLoginInfo () {
  return JSON.parse(localStorage.getItem('loginInfo'))
}

// 存储登录信息用于校验是否登录
export function setCheckLoginInfo (loginInfo) {
  sessionStorage.setItem('checkLoginInfo', JSON.stringify(loginInfo))
}

// 获取校验的登录信息
export function getCheckLoginInfo () {
  return JSON.parse(sessionStorage.getItem('checkLoginInfo'))
}

// 存储登录企业账号信息
export function setAccountInfo (loginInfo) {
  sessionStorage.setItem('accountInfo', JSON.stringify(loginInfo))
}

// 获取登录企业账号信息
export function getAccountInfo () {
  return JSON.parse(sessionStorage.getItem('accountInfo'))
}

// 存储配置信息
export function setConfig (loginInfo) {
  sessionStorage.setItem('configInfo', JSON.stringify(loginInfo))
}

// 获取配置信息
export function getConfig () {
  return JSON.parse(sessionStorage.getItem('configInfo'))
}

// ========== 租户相关 ==========

const TenantIdKey = 'TENANT_ID'
const TenantNameKey = 'TENANT_NAME'

export function getTenantName () {
  return localStorage.getItem(TenantNameKey)
}

export function setTenantName (username) {
  localStorage.setItem(TenantNameKey, username)
}

export function removeTenantName () {
  localStorage.removeItem(TenantNameKey)
}

export function getTenantId () {
  return localStorage.getItem(TenantIdKey)
}

export function setTenantId (username) {
  localStorage.setItem(TenantIdKey, username)
}

export function removeTenantId () {
  localStorage.removeItem(TenantIdKey)
}



// WEBPACK FOOTER //
// ./src/util/auth.js